import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
import { theme } from '@chakra-ui/theme';
import { inputButtonHeights } from '../sizes';

const buttonTheme = theme.components.Button;

const cardHeader = defineStyle((props) => ({
  ...buttonTheme.variants?.solid({
    ...props,
  }),
  height: 6,
  letterSpacing: 0,
  py: 2,
  textTransform: 'none',
}));

const rounded = defineStyle((props) => ({
  ...buttonTheme.variants?.solid({
    ...props,
  }),
  borderRadius: 'full',
  height: 'auto',
  px: '14px',
  py: '8px',
}));

const roundedOutline = defineStyle((props) => ({
  ...buttonTheme.variants?.outline({
    ...props,
  }),
  borderRadius: 'full',
  height: 'auto',
  px: '14px',
  py: '8px',
}));

const input = defineStyle((props) => ({
  ...buttonTheme.variants?.outline({
    ...props,
  }),
  borderColor: 'whiteAlpha.200',
  color: 'whiteAlpha.900',
  backgroundColor: 'input.bg',
  _hover: {
    backgroundColor: 'input.bg',
    borderColor: 'whiteAlpha.400',
  },
  _active: {
    backgroundColor: 'input.bg',
    borderColor: 'primary.600',
  },
  _expanded: {
    backgroundColor: 'input.bg',
    borderColor: 'primary.600',
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    boxShadow: `0px 0px 0px 1px ${props.theme.colors.primary[600]}`,
  },
}));

const gradient = defineStyle((props) => ({
  ...buttonTheme.variants?.solid({
    ...props,
  }),
  bg: 'blueGradient',
  _hover: {
    bg: 'blueGradient',
    opacity: 0.92,
    _disabled: {
      bg: 'blueGradient',
      opacity: 0.5,
    },
  },
  _active: {
    bg: 'blueGradient',
    opacity: 1.0,
  },
}));

export const Button = defineStyleConfig({
  defaultProps: {
    colorScheme: 'primaryButton',
    size: 'md',
  },
  variants: {
    'card-header': cardHeader,
    rounded,
    'rounded-outline': roundedOutline,
    input,
    gradient,
  },
  sizes: {
    lg: {
      ...inputButtonHeights.lg,
      px: 6,
      fontSize: 'lg',
      borderRadius: 'sm',
      fontWeight: '500',
    },
    md: {
      ...inputButtonHeights.md,
      px: 5,
      fontSize: 'md',
      borderRadius: 'sm',
      fontWeight: '500',
    },
    sm: {
      ...inputButtonHeights.sm,
      px: '10px',
      py: '6px',
      fontSize: 'sm',
      fontWeight: '500',
      borderRadius: 'sm',
    },
    xs: {
      ...inputButtonHeights.xs,
      px: 3,
      fontSize: 'xs',
      fontWeight: '500',
      borderRadius: 'xs',
    },
  },
});
